import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";

export function getTranslators() {
    return invokeApig({
        ...Paths.getTranslators()
    })
}
